import React, { Component, Fragment, useEffect, useState, useContext } from 'react';
import './style.css';
import { Layout, Switch, Menu, Tabs, Breadcrumb, Table, Button, Space, Input, Row, Col, Divider, Dropdown, Spin } from 'antd';
import { PlusOutlined, SearchOutlined, MoreOutlined, EditOutlined, SyncOutlined } from '@ant-design/icons';
import { getAllBranchesAsyn, getAllIOAsyn, getAllIDAsyn, setStatusAsyn, getUserDepartments, userDepartmentSelector, getAllUserDepartmentsAsyn, clearState, getAllIOS } from './departmentSlice';
import { useSelector, useDispatch } from 'react-redux';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { Link, useHistory, Redirect } from "react-router-dom";
import Container from '../Layout/Container';
import Can from '../../config/Can';
import ability from '../../config/ability';
const { Header, Content, Footer } = Layout;
const { Search } = Input;
const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;
const { TabPane } = Tabs;


const ntop = "none";
const nbottom = "bottomCenter";
export default function Departments() {
  // const ability = useContext(AbilityContext);
  const dispatch = useDispatch();
  let history = useHistory()

  const [isLoading, setLoading] = React.useState(false);
  const { isFetching, isSuccess, isError, errorMessage, departments, branches, ios, ids, branchCount, iosCount, idsCount } = useSelector(
    userDepartmentSelector
  );
  const defaultTab = localStorage.getItem('defaultTabDepartment') ? localStorage.getItem('defaultTabDepartment') : '1';

  const [departmentData, setDataSource] = useState([]);
  const [iosData, setIOSDataSource] = useState([]);
  const [idsData, setIDSDataSource] = useState([]);
  const [search, setSearch] = useState('');
  const [bpage, setbPage] = React.useState(1);
  const [iopage, setioPage] = React.useState(1);
  const [idpage, setidPage] = React.useState(1);
  const indexval = 0;


  useEffect(() => {
    setLoading(true);
    dispatch(clearState());
    dispatch(getAllBranchesAsyn(1));
    dispatch(getAllIOAsyn(1));
    dispatch(getAllIDAsyn(1));
    //dispatch(getUserDepartments());
    //dispatch(getAllUserDepartmentsAsyn());

  }, []);

  useEffect(() => {

    if (isError) {
      setLoading(false);

    }
    if (isSuccess) {
      setLoading(false);
      setDataSource(branches);
      setIOSDataSource(ios);
      setIDSDataSource(ids);
      // dispatch(getAllUserDepartmentsAsyn());
      // dispatch(getUserDepartments());
    }
  }, [isError, isSuccess, setLoading, branches, ios, ids, setDataSource, setIOSDataSource, setIDSDataSource]);


  const onChangeBranch = (checked, data) => {
    // console.log(`branch to ${checked}`);
    let statusData = {
      department: "Chief of Air Staff",
      code: "b",
      deptTypeName: data.b_name
    };
    //console.log(statusData)
    dispatch(setStatusAsyn(statusData));
  }

  const onChangeIOS = (checked, data) => {
    let statusData = {
      department: "Chief of Air Staff",
      code: "io",
      deptTypeName: data.io_name
    };
    // console.log(statusData)
    dispatch(setStatusAsyn(statusData));
  }

  const onChangeIDS = (checked, data) => {
    let statusData = {
      department: "Chief of Air Staff",
      code: "id",
      deptTypeName: data.id_name
    };
    //console.log(statusData)
    dispatch(setStatusAsyn(statusData));
  }

  const onChange = (checked) => {
    // console.log(`switch to ${checked}`);
  }
  // In the fifth row, other columns are merged into first column
  // by setting it's colSpan to be 0
  const renderContent = (value, row, index) => {
    const obj = {
      children: value,
      props: {},
    };
    // if (index === 4) {
    //   obj.props.colSpan = 0;
    // }
    return obj;
  };

  const handleMenuClick = (e, row) => {
    //console.log("click", row);
    // if(e.key==1){
    //  // history.push('/edit-department',{department_name:row.departmentName});
    //   history.push({
    //     pathname: '/edit-department',
    //    // search: '?query=abc',
    //     state: { departmentName:row.departmentName }
    // });
    // }
  }

  const menu = (row) => (
    <Menu onClick={(e) => handleMenuClick(e, row)}>
      <Menu.Item key="1">
        <EditOutlined /> &nbsp; Edit
      </Menu.Item>
    </Menu>
  );

  //..........Branch menu..........................//

  const handleBranchMenuClick = (e, row) => {
    //console.log("click", row);
    if (e.key == 1) {
      // history.push('/edit-department',{department_name:row.departmentName});
      history.push({
        pathname: '/view-branch',
        // search: '?query=abc',
        state: { branchName: row.b_name }
      });
    }
  }

  const branchmenu = (row) => (
    <Menu onClick={(e) => handleBranchMenuClick(e, row)}>
      <Menu.Item key="1">
        <EditOutlined /> &nbsp; Edit
      </Menu.Item>
    </Menu>
  );

  const handleBranchView = (row) => {
    history.push({
      pathname: '/view-branch',
      // search: '?query=abc',
      state: { branchName: row.b_name }
    });
  }
  //..........Branch menu..........................//

  const columns = [
    {
      title: 'SI.NO.',
      dataIndex: 'b_name',
      render: (text, row, index) => {
        return {
          children: (bpage - 1) * 10 + (index + 1),
          props: {
            //colSpan: 5,
          },
        };
      },
      // render:{(value, item, index) => (page - 1) * 10 + index},
      // render: (text, row, index) => {
      //   return {
      //     children: index+1,
      //     props: {
      //       //colSpan: 5,
      //     },
      //   };
      // },
      //sorter: (a, b) => a.departmentName.localeCompare(b.departmentName),
      //sorter: (a, b) =>a.departmentName.toLowerCase().localeCompare(b.departmentName.toLowerCase()),
      //sorter: (a, b) =>a.departmentName.localeCompare(b.departmentName, undefined, {sensitivity: 'base'})
    },
    {
      title: 'Branch Name',
      dataIndex: 'b_name',
      render: (text, row, index) => {
        return {
          // children: <a onClick={() => handleViewDepartment(row)}>{text}</a>,
          children: <a onClick={() => handleBranchView(row)}>{text}</a>,
          props: {
            //colSpan: 5,
          },
        };
      },
      //sorter: (a, b) => a.departmentName.localeCompare(b.departmentName),
      //sorter: (a, b) =>a.departmentName.toLowerCase().localeCompare(b.departmentName.toLowerCase()),
      //sorter: (a, b) =>a.departmentName.localeCompare(b.departmentName, undefined, {sensitivity: 'base'})
    },
    {
      title: 'Total Directorate',
      dataIndex: 'directorateCount',
      render: renderContent,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      className: ability.can('manageB', 'enable/disable') ? 'show' : 'hide',
      render: (text, row, index) => {
        return {
          children: <Can I="manageB" a="enable/disable">
            {
              row.active ? <Switch defaultChecked onChange={(v) => onChangeBranch(v, row)} /> : <Switch onChange={(v) => onChangeBranch(v, row)} />
            }</Can>
        };
      },
    },
    {
      title: '',
      dataIndex: '',
      key: 'x',
      fixed: "left",
      width: 100,
      className: ability.can('manageB', 'edit') ? 'show' : 'hide',
      render: (text, row, index) => (
        <Can I="manageB" a="edit">
          <Dropdown
            overlay={() => branchmenu(row)}
            trigger={["click"]}
            placement="bottomRight"
            arrow
          >

            <a
              style={{ color: "#c5c7cd", fontSize: 25 }}
              onClick={(e) => e.preventDefault()}
            >
              <MoreOutlined />
            </a>

          </Dropdown>
        </Can>
      ),
      //render: () => <a style={{color:'#c5c7cd',fontSize:25}}><MoreOutlined /></a>,
    },
  ];

  //..........Office menu..........................//

  const handleOfficeMenuClick = (e, row) => {
    //console.log("click", row);
    if (e.key == 1) {
      // history.push('/edit-department',{department_name:row.departmentName});
      history.push({
        pathname: '/view-office',
        // search: '?query=abc',
        state: { ioName: row.io_name }
      });
    }
  }

  const officemenu = (row) => (
    <Menu onClick={(e) => handleOfficeMenuClick(e, row)}>
      <Menu.Item key="1">
        <EditOutlined /> &nbsp; Edit
      </Menu.Item>
    </Menu>
  );

  const handleOfficeView = (row) => {
    history.push({
      pathname: '/view-office',
      // search: '?query=abc',
      state: { ioName: row.io_name }
    });
  }

  //..........Office menu..........................//
  const columnsIOS = [
    {
      title: 'SI.NO.',
      dataIndex: 'io_name',
      render: (text, row, index) => {
        return {
          children: (iopage - 1) * 10 + (index + 1),
          props: {
            //colSpan: 5,
          },
        };
      },
      //sorter: (a, b) => a.departmentName.localeCompare(b.departmentName),
      //sorter: (a, b) =>a.departmentName.toLowerCase().localeCompare(b.departmentName.toLowerCase()),
      //sorter: (a, b) =>a.departmentName.localeCompare(b.departmentName, undefined, {sensitivity: 'base'})
    },
    {
      title: 'Independent Office Name',
      dataIndex: 'io_name',
      render: (text, row, index) => {
        return {
          // children: <a onClick={() => handleViewDepartment(row)}>{text}</a>,
          children: <a onClick={() => handleOfficeView(row)}>{text}</a>,
          props: {
            //colSpan: 5,
          },
        };
      },
      //sorter: (a, b) => a.departmentName.localeCompare(b.departmentName),
      //sorter: (a, b) =>a.departmentName.toLowerCase().localeCompare(b.departmentName.toLowerCase()),
      //sorter: (a, b) =>a.departmentName.localeCompare(b.departmentName, undefined, {sensitivity: 'base'})
    },
    {
      title: 'Status',
      dataIndex: 'status',
      className: ability.can('manageIo', 'enable/disable') ? 'show' : 'hide',
      render: (text, row, index) => {
        return {
          children: <Can I="manageIo" a="enable/disable">
            {row.active ? <Switch defaultChecked onChange={(v) => onChangeIOS(v, row)} /> : <Switch onChange={(v) => onChangeIOS(v, row)} />
            }</Can>,
          props: {
            //colSpan: 5,
          },
        };
      },
    },
    {
      title: '',
      dataIndex: '',
      key: 'x',
      fixed: "left",
      width: 100,
      className: ability.can('manageIo', 'edit') ? 'show' : 'hide',
      render: (text, row, index) => (
        <Can I="manageIo" a="edit">
          <Dropdown
            overlay={() => officemenu(row)}
            trigger={["click"]}
            placement="bottomRight"
            arrow
          >
            <a
              style={{ color: "#c5c7cd", fontSize: 25 }}
              onClick={(e) => e.preventDefault()}
            >
              <MoreOutlined />
            </a>
          </Dropdown>
        </Can>
      ),
      //render: () => <a style={{color:'#c5c7cd',fontSize:25}}><MoreOutlined /></a>,
    },
  ];


  //..........ID menu..........................//

  const handleIDMenuClick = (e, row) => {
    //console.log("click", row);
    if (e.key == 1) {
      // history.push('/edit-department',{department_name:row.departmentName});
      history.push({
        pathname: '/view-independent-directorate',
        // search: '?query=abc',
        state: { idName: row.id_name }
      });
    }
  }

  const idmenu = (row) => (
    <Menu onClick={(e) => handleIDMenuClick(e, row)}>
      <Menu.Item key="1">
        <EditOutlined /> &nbsp; Edit
      </Menu.Item>
    </Menu>
  );

  const handleIDView = (row) => {
    history.push({
      pathname: '/view-independent-directorate',
      // search: '?query=abc',
      state: { idName: row.id_name }
    });
  }

  //..........ID menu..........................//


  const columnsIDS = [
    {
      title: 'SI.NO.',
      dataIndex: 'id_name',
      render: (text, row, index) => {
        return {
          children: (idpage - 1) * 10 + (index + 1),
          props: {
            //colSpan: 5,
          },
        };
      },
      //sorter: (a, b) => a.departmentName.localeCompare(b.departmentName),
      //sorter: (a, b) =>a.departmentName.toLowerCase().localeCompare(b.departmentName.toLowerCase()),
      //sorter: (a, b) =>a.departmentName.localeCompare(b.departmentName, undefined, {sensitivity: 'base'})
    },
    {
      title: 'Independent Directorate Name',
      dataIndex: 'id_name',
      render: (text, row, index) => {
        return {
          // children: <a onClick={() => handleViewDepartment(row)}>{text}</a>,
          children: <a onClick={() => handleIDView(row)}>{text}</a>,
          props: {
            //colSpan: 5,
          },
        };
      },
      //sorter: (a, b) => a.departmentName.localeCompare(b.departmentName),
      //sorter: (a, b) =>a.departmentName.toLowerCase().localeCompare(b.departmentName.toLowerCase()),
      //sorter: (a, b) =>a.departmentName.localeCompare(b.departmentName, undefined, {sensitivity: 'base'})
    },
    {
      title: 'Status',
      dataIndex: 'status',
      className: ability.can('manageId', 'enable/disable') ? 'show' : 'hide',
      render: (text, row, index) => {
        return {
          children: <Can I="manageId" a="enable/disable">
            {
              row.active ? <Switch defaultChecked onChange={(v) => onChangeIDS(v, row)} /> : <Switch onChange={(v) => onChangeIDS(v, row)} />
            }</Can>,
          props: {
            //colSpan: 5,
          },
        };
      },
    },
    {
      title: '',
      dataIndex: '',
      key: 'x',
      fixed: "left",
      width: 100,
      className: ability.can('manageId', 'edit') ? 'show' : 'hide',
      render: (text, row, index) => (
        <Can I="manageId" a="edit">
          <Dropdown
            overlay={() => idmenu(row)}
            trigger={["click"]}
            placement="bottomRight"
            arrow
          >
            <a
              style={{ color: "#c5c7cd", fontSize: 25 }}
              onClick={(e) => e.preventDefault()}
            >
              <MoreOutlined />
            </a>
          </Dropdown>
        </Can>
      ),
      //render: () => <a style={{color:'#c5c7cd',fontSize:25}}><MoreOutlined /></a>,
    },
  ];


  // useEffect(() => {
  //   setLoading(true);
  //   dispatch(getAllUserDepartmentsAsyn());
  //   dispatch(getUserDepartments());
  // }, []);

  const handleViewDepartment = (row) => {
    history.push({
      pathname: '/view-department',
      // search: '?query=abc',
      state: { departmentName: row.departmentName }
    });
  }

  const callback = (key) => {
    // console.log(key);
    localStorage.setItem('defaultTabDepartment', key);
  }

  const handleChangeBranch = (v) => {
    setbPage(v.current);
    dispatch(getAllBranchesAsyn(v.current));
  }

  const handleChangeIOS = (v) => {
    setioPage(v.current);
    dispatch(getAllIOAsyn(v.current));
  }

  const handleChangeIDS = (v) => {
    setidPage(v.current)
    dispatch(getAllIDAsyn(v.current));
  }
  //console.log(departments)
  // const dataSource = isFetching
  //   ? [] 
  //   : departments.map(row => ({ name: row.departmentName, Branches: row.Branches }));
  // const dataSource = isLoading ? [] : departmentData;
  let dataSource = departmentData;
  dataSource = dataSource ? dataSource.slice().sort((a, b) => a.b_name.toLowerCase().localeCompare(b.b_name.toLowerCase())) : [];

  let dataIOSSource = iosData;
  dataIOSSource = dataIOSSource ? dataIOSSource.slice().sort((a, b) => a.io_name.toLowerCase().localeCompare(b.io_name.toLowerCase())) : [];

  let dataIDSSource = idsData;
  dataIDSSource = dataIDSSource ? dataIDSSource.slice().sort((a, b) => a.id_name.toLowerCase().localeCompare(b.id_name.toLowerCase())) : [];


  return (
    <>
      <Container>
        {/* <Breadcrumb style={{ margin: '16px 0' }}>
        <Breadcrumb.Item>Home</Breadcrumb.Item>
        <Breadcrumb.Item>List</Breadcrumb.Item>
        <Breadcrumb.Item>App</Breadcrumb.Item>
      </Breadcrumb> */}
        {/* <div className="site-layout-content" style={{marginTop:35,border: '1px solid #dfe0eb'}}> */}
        {/* <div className="site-layout-content" style={{marginTop:35,marginBottom:35,border:"1px solid #dfe0eb"}}> */}
        <div className="site-layout-content" style={{ marginTop: 5 }}>

          <div style={{ padding: 24, paddingTop: 16 }}>
            <Spin indicator={antIcon} style={{ textAlign: 'center', width: '100%' }} spinning={isFetching} />
            <Tabs defaultActiveKey={defaultTab} onChange={callback} tabBarStyle={{ backgroundColor: "#ffffff", marginBottom: 0, paddingLeft: 16, paddingTop: 20, borderTop: '1px solid #dfe0eb', borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb' }} >
              {ability.can('manageB', 'view') &&
                <TabPane style={{ backgroundColor: "#ffffff" }} tab={"Branches (" + branchCount + ")"} key="1">
                  {/* <h2 style={{paddingLeft:16,paddingTop:20,borderTop:'1px solid #dfe0eb',borderLeft:'1px solid #dfe0eb',borderRight:'1px solid #dfe0eb',marginBottom:0}}>Departments (10)</h2> */}
                  <Space style={{ padding: 16, paddingTop: 30, width: '100%', borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb' }} size="large">
                    <Row style={{ width: '100%' }}>
                      <Col span="10">
                        {/* <Search placeholder="Search process"  size="large"  /> */}
                        <Input placeholder="Search Branch" size="large" suffix={<SearchOutlined />}
                          value={search}
                          onChange={e => {
                            const currValue = e.target.value;
                            setSearch(currValue);
                            const filteredData = branches.filter(entry =>
                              entry.b_name.includes(currValue)
                            );
                            setDataSource(filteredData);
                          }}
                        />
                      </Col>
                      <Col span="14" style={{ textAlign: 'right' }}>
                        <Space>
                          <Can I="manageB" a="add">
                            <Link to={'/add-branch'}><Button size="large" style={{ borderRadius: 5, padding: '6.4px 8px', fontWeight: 600, fontSize: 14 }} type="primary" icon={<PlusOutlined />}>Add Branch</Button></Link>
                          </Can>
                        </Space>
                      </Col>
                    </Row>


                  </Space>
                  <Table columns={columns}
                    onChange={handleChangeBranch}
                    // pagination={{ position: [ntop, nbottom],size:'small' }}
                    // pagination={{ position: [ntop, nbottom],size:'small',defaultPageSize: 10,total:50, hideOnSinglePage: true }}
                    pagination={{ position: [ntop, nbottom], size: 'small', total: branchCount, hideOnSinglePage: true }}
                    dataSource={dataSource} bordered />

                </TabPane>
              }

              {ability.can('manageIo', 'view') &&
                <TabPane style={{ backgroundColor: "#ffffff" }} tab={"Independent Offices (" + iosCount + ")"} key="2">

                  <Space style={{ padding: 16, paddingTop: 30, width: '100%', borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb' }} size="large">
                    <Row style={{ width: '100%' }}>
                      <Col span="10">
                        {/* <Search placeholder="Search process"  size="large"  /> */}
                        <Input placeholder="Search Independent Office" size="large" suffix={<SearchOutlined />}
                          value={search}
                          onChange={e => {
                            const currValue = e.target.value;
                            setSearch(currValue);
                            const filteredData = ios.filter(entry =>
                              entry.io_name.includes(currValue)
                            );
                            setIOSDataSource(filteredData);
                          }}
                        />
                      </Col>
                      <Col span="14" style={{ textAlign: 'right' }}>
                        <Space>
                          <Can I="manageIo" a="add">
                            <Link to={'/add-office'}><Button size="large" style={{ borderRadius: 5, padding: '6.4px 8px', fontWeight: 600, fontSize: 14 }} type="primary" icon={<PlusOutlined />}>Add Office</Button></Link>
                          </Can>
                        </Space>
                      </Col>
                    </Row>


                  </Space>
                  <Table columns={columnsIOS}
                    onChange={handleChangeIOS}
                    // pagination={{ position: [ntop, nbottom],size:'small' }}
                    // pagination={{ position: [ntop, nbottom],size:'small',defaultPageSize: 10,total:50, hideOnSinglePage: true }}
                    pagination={{ position: [ntop, nbottom], size: 'small', total: iosCount, hideOnSinglePage: true }}
                    dataSource={dataIOSSource} bordered />

                </TabPane>
              }
              {ability.can('manageId', 'view') &&
                <TabPane style={{ backgroundColor: "#ffffff" }} tab={"Independent Directorate (" + idsCount + ")"} key="3">

                  <Space style={{ padding: 16, paddingTop: 30, width: '100%', borderLeft: '1px solid #dfe0eb', borderRight: '1px solid #dfe0eb' }} size="large">
                    <Row style={{ width: '100%' }}>
                      <Col span="10">
                        {/* <Search placeholder="Search process"  size="large"  /> */}
                        <Input placeholder="Search Directorate" size="large" suffix={<SearchOutlined />}
                          value={search}
                          onChange={e => {
                            const currValue = e.target.value;
                            setSearch(currValue);
                            const filteredData = ids.filter(entry =>
                              entry.id_name.includes(currValue)
                            );
                            setIDSDataSource(filteredData);
                          }}
                        />
                      </Col>
                      <Col span="14" style={{ textAlign: 'right' }}>
                        <Space>
                          <Can I="manageId" a="add">
                            <Link to={'/add-directorate'} ><Button size="large" style={{ borderRadius: 5, padding: '6.4px 8px', fontWeight: 600, fontSize: 14 }} type="primary" icon={<PlusOutlined />}>Add Directorate</Button></Link>
                          </Can>
                        </Space>
                      </Col>
                    </Row>


                  </Space>
                  <Table columns={columnsIDS}
                    onChange={handleChangeIDS}
                    // pagination={{ position: [ntop, nbottom],size:'small' }}
                    // pagination={{ position: [ntop, nbottom],size:'small',defaultPageSize: 10,total:50, hideOnSinglePage: true }}
                    pagination={{ position: [ntop, nbottom], size: 'small', total: idsCount, hideOnSinglePage: true }}
                    dataSource={dataIDSSource} bordered />

                </TabPane>
              }

            </Tabs>



          </div>

        </div>
      </Container>
    </>
  );
}
